export default __webpack_public_path__ + "static/media/undraw_in_the_office_re_jtgc.354bb46c.svg";